<template>
  <v-os-popup
    v-model="isShow"
    title="选择服务方式"
    @close="handleClose"
    :minHeightFill="false"
    container="body"
  >
    <div class="s-item border1px" @click="appointRepair">
        <div class="s-title">预约到店</div>
        <div class="s-sub">预约到店，提前向服务中心确认库存，省时省心</div>
        <v-icon  name="arrow-right-order" class="g-arrow" />
    </div>
    <div class="s-item" @click="sendRepair">
        <div class="s-title">寄修服务</div>
        <div class="s-sub">足不出户，双向免邮</div>
        <v-icon  name="arrow-right-order" class="g-arrow" />
    </div>
  </v-os-popup>
  </template>
  <script>
import create from '../create'
export default create({
    name: 'aft-service-pop',
    components: {
    },
    props: {
        orderNo: String || Number || Boolean,
        orderItemNo: String || Number || Boolean
    },
    data() {
        return {
            isShow:false
        }
    },
    computed: {
    },
    methods: {
        open(params){
            this.currentNo = params?.orderNo||this.orderNo
            this.isShow = true
        },
        handleClose() {
            this.isShow = false
        },
        appointRepair() {
            window.location.replace(`https://www.vivo.com.cn/service/s/repair/confirm/1?shopOrderNo=${this.orderNo}&shopOrderItemNo=${this.orderItemNo}`)
        },
        sendRepair(){
            window.location.replace(`https://www.vivo.com.cn/service/s/repair/confirm/2?shopOrderNo=${this.orderNo}&shopOrderItemNo=${this.orderItemNo}`)
        }
    }
})
  </script>
  <style lang="scss" scoped src="./index.scss"></style>